/*
  Pushes the page content below the fixed header (#headerComplete).

  Updated 2026-10-12. The previous version:
  - only ran after every resource had loaded (window.onload), keeping #MainContent
    invisible (opacity: 0 in base.css) until then;
  - on every "resize" reset the content to margin-top 0 and animated it back down
    over 0.9s. On phones "resize" fires while scrolling (the address bar collapses
    and expands), so the page jumped up and down during scroll.
  Now the margin is set directly, as soon as the page is ready, and recalculated
  only when the screen width or the header height actually changes.
*/
(function () {
  var lastWidth = window.innerWidth;

  function FixHeader() {
    var header = document.getElementById("headerComplete");
    var mainContent = document.getElementById("MainContent");
    if (!header || !mainContent) return;

    var headerHeight = header.offsetHeight;
    var marginTop = headerHeight > 36 ? headerHeight + "px" : "0px";

    if (mainContent.style.marginTop !== marginTop) {
      mainContent.style.marginTop = marginTop;
    }
    if (mainContent.style.opacity !== "1") {
      mainContent.style.transition = "opacity 0.3s ease";
      mainContent.style.opacity = "1";
    }
  }

  window.FixHeader = FixHeader;

  FixHeader();
  document.addEventListener("DOMContentLoaded", FixHeader);
  window.addEventListener("load", FixHeader);

  window.addEventListener("resize", function () {
    if (window.innerWidth !== lastWidth) {
      lastWidth = window.innerWidth;
      FixHeader();
    }
  });

  // The header can change height after fonts/logo load or when the menu bar changes
  if ("ResizeObserver" in window) {
    var header = document.getElementById("headerComplete");
    if (header) new ResizeObserver(FixHeader).observe(header);
  }
})();
